import { defineMessages } from 'react-intl';

export default defineMessages({
  openIn: {
    id: 'externalAgentMenu.openIn',
    defaultMessage: 'Open in {agent}',
  },
  openInTitle: {
    id: 'externalAgentMenu.openInTitle',
    defaultMessage: 'Open {agent} with a FileSpin prompt',
  },
  connectAgent: {
    id: 'externalAgentMenu.connectAgent',
    defaultMessage: 'Connect FileSpin to {agent}',
  },
  connectAgentShort: {
    id: 'externalAgentMenu.connectAgentShort',
    defaultMessage: 'Connect',
  },
  panelPrompt: {
    id: 'externalAgentMenu.panelPrompt',
    defaultMessage: 'Prefer {agent}? Use FileSpin there too.',
  },
  useInAgent: {
    id: 'externalAgentMenu.useInAgent',
    defaultMessage: 'Use FileSpin in {agent}',
  },
  promptsHeading: {
    id: 'externalAgentMenu.promptsHeading',
    defaultMessage: 'Prompts',
  },
  defaultTool: {
    id: 'externalAgentMenu.defaultTool',
    defaultMessage: 'Default tool',
  },
  configureMcp: {
    id: 'externalAgentMenu.configureMcp',
    defaultMessage: 'How to connect FileSpin (MCP)',
  },
  prompt_get_started_text: {
    id: 'externalAgentMenu.prompt.getStarted.text',
    defaultMessage:
      'Using my FileSpin connector, look at my FileSpin account and asset library, then suggest a few useful things you can do for me. Use list_prompts to see the FileSpin prompt templates.',
  },
  prompt_weekly_uploads_label: {
    id: 'externalAgentMenu.prompt.weeklyUploads.label',
    defaultMessage: "Summarise this week's uploads",
  },
  prompt_weekly_uploads_text: {
    id: 'externalAgentMenu.prompt.weeklyUploads.text',
    defaultMessage:
      'Using my FileSpin connector, summarise the assets uploaded to FileSpin in the last 7 days: how many, which file types, and anything that looks untagged or incomplete.',
  },
  prompt_missing_metadata_label: {
    id: 'externalAgentMenu.prompt.missingMetadata.label',
    defaultMessage: 'Find assets missing required metadata',
  },
  prompt_missing_metadata_text: {
    id: 'externalAgentMenu.prompt.missingMetadata.text',
    defaultMessage:
      'Using my FileSpin connector, check my FileSpin metadata schemas for required fields, then find recent assets that are missing them. List each asset with the fields it is missing.',
  },
  prompt_share_approvals_label: {
    id: 'externalAgentMenu.prompt.shareApprovals.label',
    defaultMessage: 'Review my share approvals',
  },
  prompt_share_approvals_text: {
    id: 'externalAgentMenu.prompt.shareApprovals.text',
    defaultMessage:
      'Using my FileSpin connector, review the approvals on my FileSpin asset shares. Summarise what has been approved, what was rejected (with comments), and what is still waiting.',
  },
  prompt_campaign_links_label: {
    id: 'externalAgentMenu.prompt.campaignLinks.label',
    defaultMessage: 'Prepare campaign links',
  },
  prompt_campaign_links_text: {
    id: 'externalAgentMenu.prompt.campaignLinks.text',
    defaultMessage:
      'Using my FileSpin connector, help me prepare tracked campaign links for FileSpin assets. First ask me which assets, which campaign, and which channels, then generate the links.',
  },
});
